import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-guard-confirm-modal',
  templateUrl: './guard-confirm-modal.component.html',
  styleUrls: ['./guard-confirm-modal.component.scss'],
})
export class GuardConfirmModalComponent {
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  reject(): void {
    this.ref.close(false);
  }

  accept(): void {
    this.ref.close(true);
  }
}
